// extracted by mini-css-extract-plugin
export default {"items":"reg_ite_JDWdP"};